import { request, success, failure, DEPARTMENTS } from "./utilities";
import { getDepartmentList, addNewDepartment, deleteDepartment, getRecess } from "../api";
import { APP_SETTINGS } from "../../config";
import { GetRequest, PostRequest } from '../api/genericApiCalls'

export function getAllDepartments(token) {
    return (dispatch) => {
        dispatch(request(DEPARTMENTS.GET_ALL_DEPARTMENTS_REQUEST));
        var path = APP_SETTINGS.API_PATH.DEPARTMENTS.getAllDepartments
        PostRequest(path, null, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENTS.GET_ALL_DEPARTMENTS_SUCCESS, res.data.data));
            }
            else {
                dispatch(failure(DEPARTMENTS.GET_ALL_DEPARTMENTS_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENTS.GET_ALL_DEPARTMENTS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function getDepartmentsSelectList(token) {
    return (dispatch) => {
        dispatch(request(DEPARTMENTS.GET_DEPARTMENTS_SELECTLIST_REQUEST));
        var path = APP_SETTINGS.API_PATH.DEPARTMENTS.getDepartmentsSelectList
        GetRequest(path, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENTS.GET_DEPARTMENTS_SELECTLIST_SUCCESS, res.data.data));
            }
            else {
                dispatch(failure(DEPARTMENTS.GET_DEPARTMENTS_SELECTLIST_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENTS.GET_DEPARTMENTS_SELECTLIST_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function saveDepartment(deptData, token, close) {
    return (dispatch) => {
        dispatch(request(DEPARTMENTS.ADD_DEPARTMENT_REQUEST));
        var path = APP_SETTINGS.API_PATH.DEPARTMENTS.saveDepartment
        PostRequest(path, deptData, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENTS.ADD_DEPARTMENT_SUCCESS, res.data.data));
                if (close) { close(); }
            }
            else {
                dispatch(success(DEPARTMENTS.ADD_DEPARTMENT_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENTS.ADD_DEPARTMENT_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function editDepartment(deptData, token, close) {
    return (dispatch) => {
        dispatch(request(DEPARTMENTS.EDIT_DEPARTMENT_REQUEST));
        var path = APP_SETTINGS.API_PATH.DEPARTMENTS.saveDepartment
        PostRequest(path, deptData, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENTS.EDIT_DEPARTMENT_SUCCESS, res.data.data));
                if (close) { close() }
            }
            else {
                dispatch(success(DEPARTMENTS.EDIT_DEPARTMENT_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENTS.EDIT_DEPARTMENT_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function removeDepartment(info, token, close) {
    return (dispatch) => {
        dispatch(request(DEPARTMENTS.DELETE_DEPARTMENT_REQUEST));
        var path = `${APP_SETTINGS.API_PATH.DEPARTMENTS.deleteDepartment}?id=${info.departmentId}`;
        PostRequest(path, null, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENTS.DELETE_DEPARTMENT_SUCCESS, res.data.data, info));
                if (close) {
                    close();
                }
            }
            else {
                dispatch(failure(DEPARTMENTS.DELETE_DEPARTMENT_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENTS.DELETE_DEPARTMENT_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}